// Mock data for VISO Connect B2B Services Website

export const companyInfo = {
  name: "VISO Connect",
  tagline: "Operational Support That Helps Businesses Scale",
  description: "We support growing companies with reliable backend operations, credit control, customer support, and lead generation — delivered by experienced teams and proven processes.",
  supportingLine: "Built to integrate seamlessly with your existing workflows.",
  email: "Help@visoconnect.in",
  phone: "+91 7999931517",
  phone2: "+91 8091730315",
  address: {
    street: "75A, Btown, Shivalik City, Landra",
    city: "Kharar",
    postcode: "140307",
    country: "India"
  }
};

export const services = [
  {
    id: "backend-support",
    title: "Backend Support",
    shortDescription: "Keep operations running smoothly without growing overhead.",
    fullDescription: "We manage day-to-day backend tasks including office operations, data management, reporting, and process support — so your internal teams stay focused on core priorities.",
    icon: "Settings",
    benefits: [
      "Reduce operational overhead significantly",
      "Scalable support that grows with your business",
      "UK-based team with enterprise experience",
      "Secure, GDPR-compliant processes"
    ],
    useCases: [
      "Office operations management",
      "Data management and reporting",
      "Process support and optimisation",
      "Administrative task handling"
    ]
  },
  {
    id: "credit-control",
    title: "Credit Control",
    shortDescription: "Professional follow-ups that protect cash flow and relationships.",
    fullDescription: "We handle customer dues management, payment follow-ups, and reconciliation with a structured, respectful approach aligned to enterprise standards.",
    icon: "PoundSterling",
    benefits: [
      "Protect cash flow with structured follow-ups",
      "Professional, relationship-preserving approach",
      "Detailed reporting and reconciliation",
      "Enterprise-standard processes"
    ],
    useCases: [
      "Customer dues management",
      "Payment follow-ups",
      "Account reconciliation",
      "Credit policy implementation"
    ]
  },
  {
    id: "customer-support",
    title: "24/7 Customer Support",
    shortDescription: "Always-on support across chat, email, and voice.",
    fullDescription: "Our trained support teams deliver consistent, SLA-driven customer assistance designed to meet modern customer expectations around responsiveness and clarity.",
    icon: "Headphones",
    benefits: [
      "Round-the-clock availability",
      "Multi-channel support (chat, email, voice)",
      "SLA-driven service delivery",
      "Consistent, quality responses"
    ],
    useCases: [
      "Customer enquiry handling",
      "Technical support triage",
      "Order and booking management",
      "Issue resolution and escalation"
    ]
  },
  {
    id: "lead-generation",
    title: "Lead Generation",
    shortDescription: "Consistent, qualified leads — not just outreach.",
    fullDescription: "We run targeted calling and email campaigns to identify, qualify, and deliver sales-ready leads backed by clear reporting and feedback loops.",
    icon: "TrendingUp",
    benefits: [
      "Sales-ready qualified leads",
      "Targeted calling and email campaigns",
      "Clear reporting and feedback loops",
      "Seamless CRM integration"
    ],
    useCases: [
      "B2B prospecting campaigns",
      "Lead qualification and scoring",
      "Appointment setting",
      "Campaign reporting and analysis"
    ]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Process-Driven Delivery",
    description: "Every engagement follows tested, documented processes that ensure consistency and quality.",
    icon: "Settings"
  },
  {
    id: 2,
    title: "Dedicated Support Teams",
    description: "Your account is managed by focused teams who understand your business and priorities.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Scalable Engagement Models",
    description: "Start small and scale as needed — our flexible models adapt to your growth trajectory.",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Clear Reporting & Accountability",
    description: "Regular reporting and transparent metrics keep you informed and in control.",
    icon: "FileText"
  }
];

export const whyVisoShort = [
  "Process-driven delivery",
  "Dedicated support teams",
  "Scalable engagement models",
  "Clear reporting and accountability"
];

export const stats = [
  { id: 1, value: 50, suffix: "+", label: "Clients Served" },
  { id: 2, value: 99, suffix: "%", label: "Client Satisfaction Rate" },
  { id: 3, value: 3, suffix: "+", label: "Years of Experience" },
  { id: 4, value: 24, suffix: "/7", label: "Support Availability" }
];

export const aboutContent = {
  mission: "Our mission is to empower UK businesses with reliable, professional operational support that enables them to focus on what they do best—growing their business and serving their customers.",
  values: [
    {
      title: "Integrity",
      description: "We operate with complete transparency and honesty in every interaction."
    },
    {
      title: "Excellence",
      description: "We strive for the highest standards in everything we deliver."
    },
    {
      title: "Partnership",
      description: "We see ourselves as an extension of your team, invested in your success."
    },
    {
      title: "Innovation",
      description: "We continuously improve our processes to deliver better outcomes."
    }
  ],
  story: "Founded with a vision to provide UK businesses with enterprise-grade operational support, VISO Connect has grown from a small consultancy to a trusted partner for companies across the nation. We understand the unique challenges facing British businesses and have built our services to address them directly."
};

export const testimonials = [
  {
    id: 1,
    quote: "VISO Connect transformed our credit control process. Our debtor days reduced by 35% within the first quarter.",
    author: "Sarah Thompson",
    role: "Finance Director",
    company: "Meridian Solutions Ltd"
  },
  {
    id: 2,
    quote: "Their 24/7 support team feels like an extension of our own. Professional, responsive, and truly understand our brand.",
    author: "James Mitchell",
    role: "Operations Manager",
    company: "TechFlow UK"
  },
  {
    id: 3,
    quote: "The lead generation service has been a game-changer for our sales pipeline. Quality prospects that actually convert.",
    author: "Emma Richardson",
    role: "Sales Director",
    company: "Apex Consulting"
  }
];

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" }
];
